import { useState, useEffect } from 'react';
import { subscribe, unsubscribe } from '@wh/message-bus'; //TODO change to @sb/message-bus once problem fixed with this package deploying and remove ts-ignore
import { DEFAULT_ODDS_FORMAT, MB_ON_ODDS_FORMAT_CHANGED } from '../consts';
export const useOddsFormat = () => {
    const [oddsFormat, setOddsFormat] = useState(DEFAULT_ODDS_FORMAT);
    useEffect(() => {
        const token = subscribe(MB_ON_ODDS_FORMAT_CHANGED, (t, v) => {
            setOddsFormat(v);
        });
        return () => unsubscribe(token);
    }, []);
    return oddsFormat;
};
